import global from "../../global.js";
const d3 = global.d3;

const TARGET_TYPE_NONE = 0;
const TARGET_TYPE_SELECTOR = 1;
const TARGET_TYPE_OBJECT = 2;

const log = global.log.getLogger("f_mtac.scene.interactions.draggable");

const Draggable = function Draggable({name, target, enable, start, update, end, disable, data, subject, filter}) {
    var enabled = false;
    var drag = d3.drag();

    if (subject !== undefined) {
        drag.subject(subject);
    }

    if (filter !== undefined) {
        drag.filter(filter);
    }

    Object.defineProperty(this, "enabled", {
        set: () => {},
        get: () => enabled
    });

    Object.defineProperty(this, "name", {
        set: () => {},
        get: () => name
    });

    drag.on("start", (_, n, nodes) => {
        if (typeof data === "function") {
            // sorry javascript but we need speed here
            // don't want to use a WeakMap just yet
            nodes[n]._drag_data = data();
        } else {
            nodes[n]._drag_data = data;
        }
        start(nodes[n]._drag_data, nodes[n]);
    });

    drag.on("drag", (_, n, nodes) => {
        global.event_bus.publish("scene.interaction.drag");
        update(nodes[n]._drag_data, nodes[n]);
    });

    drag.on("end", (_, n, nodes) => {
        end(nodes[n]._drag_data, nodes[n]);
        // garbage collecting data
        delete nodes[n]._drag_data;
    });

    let target_type = TARGET_TYPE_NONE;
    if ("_groups" in target && "_parents" in target) {
        target_type = TARGET_TYPE_SELECTOR;
    } else if (target.constructor.name === "Object") {
        target_type = TARGET_TYPE_OBJECT;
        var {layer, selector} = target;
        var layer_on_creating = (handle) => {
            d3.select(handle).select(selector).call(drag);
        };
        var layer_on_deleting = (handle) => {
            d3.select(handle).select(selector).on(".drag", null);
        };
    }

    this.enable = () => {
        if (enabled) {
            return;
        }
        switch(target_type) {
        case TARGET_TYPE_SELECTOR:
            target.call(drag);
            break;
        case TARGET_TYPE_OBJECT:
            layer.group.selectAll(selector).call(drag);
            layer.on("creating", layer_on_creating);
            layer.on("deleting", layer_on_deleting);
            break;
        }
        enable(data);
        log.info(`draggable ${name} enabled`);
        enabled = true;
    };

    this.disable = () => {
        if (!enabled) {
            return;
        }
        switch(target_type) {
        case TARGET_TYPE_SELECTOR:
            target.on(".drag", null);
            break;
        case TARGET_TYPE_OBJECT:
            layer.off("creating", layer_on_creating);
            layer.off("deleting", layer_on_deleting);
            layer.group.selectAll(selector).on(".drag", null);
            break;
        }
        disable(data);
        log.info(`draggable ${name} disabled`);
        enabled = false;
    };
};

export default Draggable;
